import React, { useMemo } from 'react';
import { calculateLayoutMatrix } from './helpers';
import { StyledResponsiveGridLayout } from './styled';
import 'react-grid-layout/css/styles.css';
const BREAKPOINTS = { lg: 1920, md: 1220, sm: 768, xs: 480, xxs: 0 };
const COLS = { lg: 36, md: 24, sm: 12, xs: 6, xxs: 4 };
export const LayoutGrid = function ({ cols = COLS, breakpoints = BREAKPOINTS, containerPadding = [0, 0], margin = [12, 12], rowHeight = 44, layoutData, layoutState = 'static', autolayout, ...props }) {
    const layouts = useMemo(() => calculateLayoutMatrix(layoutData, layoutState, cols, 'md', autolayout), [layoutData]);
    return (React.createElement(StyledResponsiveGridLayout, { containerPadding: containerPadding, layouts: layouts, breakpoints: breakpoints, cols: cols, rowHeight: rowHeight, margin: margin, ...props }));
};
